import React, { memo } from "react";
import moment from "moment";
import { Col, DatePicker, Form, Row } from "antd";

const { RangePicker } = DatePicker;

const Period = memo(({ getFieldDecorator }) => {
	return (
		<Row gutter={8}>
			<Col span={24}>
				<Form.Item label="Период">
					{getFieldDecorator("period", {
						initialValue: "",
						rules: [{ required: true, message: "Обязательное поле" }],
					})(
						<RangePicker
							style={{ width: "100%" }}
							showTime={{
								format: "HH:mm",
								defaultValue: [
									moment("00:00", "HH:mm"),
									moment("23:59", "HH:mm"),
								],
							}}
							format="YYYY-MM-DD HH:mm"
							placeholder={["Время начала", "Время завершения"]}
						/>
					)}
				</Form.Item>
			</Col>
		</Row>
	);
});

export default Period;
